/* TagsColumnComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./TagsColumnRenderer");
const _ = require("lodash");

class TagsColumnComponent extends EventEmitter {
    constructor(tags) {
        super();

        this._tags = this.setTags(tags);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._tags = undefined;
        this._displayTags = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setTags(newVal) {
        this._tags = newVal;
        this._displayTags = "";
        if (!_.isUndefined(this._tags)) {
            this._tags.forEach((tag) => {
                if (this._displayTags.length === 0) {
                    this._displayTags += tag;
                } else {
                    this._displayTags += ", " + tag;
                }
            });
        }
        this.emit("DisplayTags", this._displayTags);
        return this;
    }
    getTags() {
        return this._tags;
    }
    getDisplayTags() {
        return this._displayTags;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = TagsColumnComponent;
